import { search } from 'node-emoji';
import React, { useState } from 'react';
import InputText from 'src/components/InputText/InputText';

interface EmojiPickerProps {
    onSelect: (emoji: string) => void;
    className?: string;
}

const EmojiPicker = ({ onSelect, className = '' }: EmojiPickerProps) => {
    const [searchTerm, setSearchTerm] = useState('');

    const escapeRegExp = (string: string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const filteredEmojis = searchTerm ? search(escapeRegExp(searchTerm)).slice(0, 50) : search('').slice(0, 50);

    return (
        <div
            className={`rounded-[10px] border border-utilityGray200 shadow-md bg-white my-1.5 p-3 z-[1] w-[295px] left-6 absolute max-h-[300px] flex flex-col space-y-1.5 overflow-hidden ${className}`}
        >
            <InputText placeholder="Search emojis" onChangeFunc={(e) => setSearchTerm(e.target.value)} value={searchTerm} />
            <div className="flex flex-wrap gap-x-2 gap-y-1.5 overflow-y-auto custom-scrollbar-v2">
                {filteredEmojis.map(({ emoji, name }) => (
                    <button key={name} type="button" onClick={() => onSelect(name)} className="text-[18px] leading-[26px] transition-transform">
                        {emoji}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default EmojiPicker;
